var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    {
      staticClass: "app-card bottom-actions__card pa-4",
      attrs: {
        height: "100%"
      }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "justify-center pt-0"
        },
        [_c("h2", [_vm._v("SSL Certificate")])]
      ),
      _c("gg-card-text", [
        _c(
          "p",
          {
            staticClass: "text-center"
          },
          [_vm._v("Save SSL files locally using the button below.")]
        )
      ]),
      _c(
        "v-card-actions",
        {
          staticClass: "bottom-actions pb-0"
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center"
                },
                [
                  _c(
                    "gg-btn",
                    {
                      staticClass: "justify-center",
                      on: {
                        click: function click($event) {
                          return _vm.download("pem")
                        }
                      }
                    },
                    [_vm._v("Download Files")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }